<template>
  <ValidationObserver tag="form" @submit.prevent="submitReview">
    <HMModalHeader
      :title="$t('PRODUCTS.TITLE.SUBMIT_A_REVIEW')"
      @close="close"
    />
    <HMRatingInput
      v-model="rating"
      :required="true"
      :iconType="currentStudio.rating_icon_type"
    />
    <ValidationProvider name="review" class="form-group" tag="div">
      <HMTextarea
        :placeholder="$t('PRODUCTS.TEXT.YOUR_OPTIONAL_COMMENT')"
        v-model="review"
        :required="true"
        minHeight="100px"
      ></HMTextarea>
    </ValidationProvider>
    <HMModalFooter
      :close="close"
      :disabled="isSubmitting || !rating"
      :submitButton="$t('PRODUCTS.BUTTON.SUBMIT_REVIEW')"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductReviewsModal',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
    studioURL: {
      type: String,
      required: true,
    },
    initialRating: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isSubmitting: false,
      review: '',
      rating: 0,
    };
  },
  computed: {
    ...mapGetters({
      currentStudio: 'studio/currentStudio',
    }),
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async submitReview() {
      this.isSubmitting = true;
      try {
        await this.$store.dispatch('product/studentSubmitReview', {
          studioURL: this.studioURL,
          productId: this.productId,
          review: this.review,
          rating: this.rating,
        });
      } catch (e) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('PRODUCTS.ERROR.SUBMIT_REVIEW'),
          text: e.message,
        });
      }
      this.isSubmitting = false;
      this.$parent.$emit('review-submitted');
      this.close();
    },
  },
  mounted() {
    this.rating = this.initialRating;
  },
};
</script>
